import { CJAtelier } from 'types/cj';
import { EleveGroup } from 'types/eleveGroups';

/**
 * Get the groups available for a specific atelier.
 * Regular groups are always available to all ateliers.
 * Ephemeral groups are only shown if they belong to this specific atelier.
 */
export function getGroupsForAtelier(
  atelierId: string,
  ateliers: CJAtelier[],
  regularGroups: EleveGroup[],
  ephemeralGroups: EleveGroup[],
): EleveGroup[] {
  const currentAtelier = ateliers.find(a => a.id === atelierId);

  // Start with all regular groups (always available to all ateliers)
  const result = [...regularGroups];

  // Add ONLY ephemeral groups that belong to THIS atelier
  ephemeralGroups.forEach(group => {
    const isUsedByThis =
      currentAtelier?.groupPivots?.some(gp => gp.id === group.id) ||
      currentAtelier?.pendingEphemeralGroups?.some(peg => peg.id === group.id);

    if (isUsedByThis) {
      result.push(group);
    }
  });

  return result;
}
